// extracted by mini-css-extract-plugin
export default {"addButton":"TeachersTable_addButton__CKCEQ","searchField":"TeachersTable_searchField__bUryn"};